import reducer from "./reducer";
export { default as familySettings } from "./components/index";
export { default as familySettingsReducerName } from "./constants";
export default reducer;
